import {
  AlarmModeEnum, BatteryStoreModeEnum, DroneBatteryModeEnum, LinkWorkModeEnum, AirConditionerModeEnum,
  SIMCardSlotEnum
} from '/@/types/airport-tsa'
// 机场指令集
export enum DeviceCmd {
  // 简单指令
  DebugModeOpen = 'debug_mode_open', // 调试模式开启
  DebugModeClose = 'debug_mode_close', // 调试模式关闭
  SupplementLightOpen = 'supplement_light_open', // 打开补光灯
  SupplementLightClose = 'supplement_light_close', // 关闭补光灯
  ReturnHome = 'return_home', // 一键返航
  ReturnHomeCancel = 'return_home_cancel', // 取消返航
  // 复杂指令
  DeviceReboot = 'device_reboot', // 机场重启
  DroneOpen = 'drone_open', // 飞行器开机
  DroneClose = 'drone_close', // 飞行器关机
  // DeviceCheck = 'device_check', // 一键排障（一键起飞自检）
  DeviceFormat = 'device_format', // 机场数据格式化
  DroneFormat = 'drone_format', // 飞行器数据格式化
  // 复杂指令-舱盖控制指令
  CoverOpen = 'cover_open', // 打开舱盖
  CoverClose = 'cover_close', // 关闭舱盖
  CoverForceClose = 'cover_force_close', // 强制关舱盖
  // 复杂指令-推杆控制指令
  PutterOpen = 'putter_open', // 推杆展开
  PutterClose = 'putter_close', // 推杆闭合
  // 复杂指令-充电状态指令
  ChargeOpen = 'charge_open', // 打开充电
  ChargeClose = 'charge_close', // 关闭充电
  // 复杂指令-机场声光报警、电池保养、飞行器电池保养、增强图传
  AlarmStateSwitch = 'alarm_state_switch', // 机场声光报警
  BatteryStoreModeSwitch = 'battery_store_mode_switch', // 电池运行模式切换{"1":"计划模式","2":"待命模式"}
  DroneBatteryModeSwitch = 'battery_maintenance_switch', // 电池保养状态切换{"0":"关闭","1":"开启"}
  SdrWorkModeSwitch = 'sdr_workmode_switch', // 增强图传
  // 复杂指令-机场空调工作模式切换
  AirConditionerModeSwitch = 'air_conditioner_mode_switch', // 空调工作模式切换
  // 复杂指令-机场4G链路连接状态切换
  SimSlotSwith = 'sim_slot_switch', // eSIM 和 SIM 切换

  // AI模型
  DrcAiModelSelect = 'drc_ai_model_select', // 选择AI模型
  DrcAiIdentifySet = 'drc_ai_identify_set', // AI识别开关设置
  DrcAiSpotlightZoomSet = 'drc_ai_spotlight_zoom_set', // AI跟随开关设置
  DrcAiSpotlightZoomTrack = 'drc_ai_spotlight_zoom_track', // AI识别目标跟随
  DrcAiSpotlightZoomSelect = 'drc_ai_spotlight_zoom_select', // AI框选目标跟随
  DrcAiSpotlightZoomConfirm = 'drc_ai_spotlight_zoom_confirm', // AI框选目标跟随确认
  DrcAiSpotlightZoomStop = 'drc_ai_spotlight_zoom_stop', // AI跟随停止
  DrcAiIdentifyScoreModeSet = 'drc_ai_identify_score_mode_set', // 设置AI识别置信度模式
  DrcAiIdentifyScoreSet = 'drc_ai_identify_score_set', // 设置AI识别置信度
  DrcAiIdentifyScoreReset = 'drc_ai_identify_score_reset', // 重置AI识别置信度
  DrcAiIdentifyFilterSet = 'drc_ai_identify_filter_set', // 设置AI识别过滤

}

export type DeviceCmdItemAction = AlarmModeEnum | BatteryStoreModeEnum | DroneBatteryModeEnum
| LinkWorkModeEnum | AirConditionerModeEnum | SIMCardSlotEnum

export interface DeviceCmdItem{
  label: string, // 标题
  status: string, // 当前状态
  operateText: string, // 按钮文字
  cmdKey: DeviceCmd, // 请求指令
  oppositeCmdKey?: DeviceCmd, // 相反状态指令
  action?: DeviceCmdItemAction, // 参数
  func: string, // 处理函数
  loading: boolean // 按钮loading
  disabled?: boolean // 按钮disabled
}

export const EDeviceCmdMap = {
  [DeviceCmd.ReturnHome]: '一键返航',
  [DeviceCmd.ReturnHomeCancel]: '取消返航',
}

export const EDeviceCmdFuncMap = {
  [DeviceCmd.ReturnHome]: 'returnHome',
  [DeviceCmd.ReturnHomeCancel]: 'returnHomeCancel',
  [DeviceCmd.DeviceReboot]: 'deviceReboot',
}

export const noDebugCmdList: DeviceCmdItem[] = [
  {
    label: EDeviceCmdMap[DeviceCmd.ReturnHome],
    status: '--',
    operateText: EDeviceCmdMap[DeviceCmd.ReturnHome],
    cmdKey: DeviceCmd.ReturnHome,
    func: EDeviceCmdFuncMap[DeviceCmd.ReturnHome],
    loading: false,
  },
  {
    label: EDeviceCmdMap[DeviceCmd.ReturnHomeCancel],
    status: '--',
    operateText: EDeviceCmdMap[DeviceCmd.ReturnHomeCancel],
    cmdKey: DeviceCmd.ReturnHomeCancel,
    func: EDeviceCmdFuncMap[DeviceCmd.ReturnHomeCancel],
    loading: false,
  }
]

export const DeviceCmdItemLabelMap = {
  [DeviceCmd.DeviceReboot]: '机场系统',
  [DeviceCmd.DroneOpen]: '飞行器',
  [DeviceCmd.CoverOpen]: '舱盖',
  [DeviceCmd.CoverForceClose]: '强制关舱盖',
  [DeviceCmd.PutterOpen]: '推杆',
  [DeviceCmd.ChargeOpen]: '充电状态',
  [DeviceCmd.DeviceFormat]: '机场存储',
  [DeviceCmd.DroneFormat]: '飞行器存储',
  [DeviceCmd.SupplementLightOpen]: '补光灯',
  [DeviceCmd.AlarmStateSwitch]: '机场声光报警',
  [DeviceCmd.BatteryStoreModeSwitch]: '电池运行模式',
  [DeviceCmd.DroneBatteryModeSwitch]: '飞行器电池保养',
  [DeviceCmd.SdrWorkModeSwitch]: '增强图传[4g]',
  [DeviceCmd.AirConditionerModeSwitch]: '空调工作模式',
  [DeviceCmd.SimSlotSwith]: '4G链路连接状态',
  [DeviceCmd.DrcAiModelSelect]: 'AI模型',
  [DeviceCmd.DrcAiIdentifySet]: 'AI识别开关',
  [DeviceCmd.DrcAiSpotlightZoomSet]: 'AI跟随开关',
  [DeviceCmd.DrcAiSpotlightZoomTrack]: 'AI识别目标跟随',
  [DeviceCmd.DrcAiSpotlightZoomSelect]: 'AI框选目标跟随',
  [DeviceCmd.DrcAiSpotlightZoomConfirm]: 'AI框选目标跟随确认',
  [DeviceCmd.DrcAiSpotlightZoomStop]: 'AI跟随停止',
  [DeviceCmd.DrcAiIdentifyScoreModeSet]: '设置AI识别置信度模式',
  [DeviceCmd.DrcAiIdentifyScoreSet]: '设置AI识别置信度',
  [DeviceCmd.DrcAiIdentifyScoreReset]: '重置AI识别置信度',
  [DeviceCmd.DrcAiIdentifyFilterSet]: '设置AI识别过滤',
}

// 机场指令
export const cmdList: DeviceCmdItem[] = [
  {
    // iconName: ,
    label: DeviceCmdItemLabelMap[DeviceCmd.DeviceReboot],
    status: '工作中',
    operateText: '重启',
    cmdKey: DeviceCmd.DeviceReboot,
    func: EDeviceCmdFuncMap[DeviceCmd.DeviceReboot],
    loading: false,
    // btnAnimationIconName: '',
    // operateTips: '',
    // statusColor: '',
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.DroneOpen],
    status: '关机',
    operateText: '开机',
    cmdKey: DeviceCmd.DroneOpen,
    oppositeCmdKey: DeviceCmd.DroneClose,
    func: 'droneStatus',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.CoverOpen],
    status: '关闭',
    operateText: '开启',
    cmdKey: DeviceCmd.CoverOpen,
    oppositeCmdKey: DeviceCmd.CoverClose,
    func: 'coverStatus',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.CoverForceClose],
    status: '关闭',
    operateText: '开启',
    cmdKey: DeviceCmd.CoverForceClose,
    oppositeCmdKey: DeviceCmd.CoverForceClose,
    func: 'coverForceStatus',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.PutterOpen],
    status: '闭合',
    operateText: '展开',
    cmdKey: DeviceCmd.PutterOpen,
    oppositeCmdKey: DeviceCmd.PutterClose,
    func: 'putterStatus',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.ChargeOpen],
    status: '未充电',
    operateText: '充电',
    cmdKey: DeviceCmd.ChargeOpen,
    oppositeCmdKey: DeviceCmd.ChargeClose,
    func: 'chargeStatus',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.DeviceFormat],
    status: '--',
    operateText: '格式化',
    cmdKey: DeviceCmd.DeviceFormat,
    func: 'deviceFormat',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.DroneFormat],
    status: '--',
    operateText: '格式化',
    cmdKey: DeviceCmd.DroneFormat,
    func: 'droneFormat',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.SupplementLightOpen],
    status: '关闭',
    operateText: '打开',
    cmdKey: DeviceCmd.SupplementLightOpen,
    oppositeCmdKey: DeviceCmd.SupplementLightClose,
    func: 'supplementLightStatus',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.AlarmStateSwitch],
    status: '关闭',
    operateText: '打开',
    cmdKey: DeviceCmd.AlarmStateSwitch,
    action: AlarmModeEnum.OPEN,
    func: 'alarmState',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.BatteryStoreModeSwitch],
    status: '计划',
    operateText: '应急',
    cmdKey: DeviceCmd.BatteryStoreModeSwitch,
    action: BatteryStoreModeEnum.BATTERY_EMERGENCY_STORE,
    func: 'batteryStoreMode',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.DroneBatteryModeSwitch],
    status: '--',
    operateText: '保养',
    cmdKey: DeviceCmd.DroneBatteryModeSwitch,
    action: DroneBatteryModeEnum.OPEN,
    func: 'droneBatteryMode',
    loading: false,
    disabled: true,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.SdrWorkModeSwitch],
    status: '--',
    operateText: '开启',
    cmdKey: DeviceCmd.SdrWorkModeSwitch,
    action: LinkWorkModeEnum.FourG_FUSION_MODE,
    func: 'sdrWorkMode',
    loading: false,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.AirConditionerModeSwitch],
    status: '制冷模式',
    operateText: '空闲模式',
    cmdKey: DeviceCmd.AirConditionerModeSwitch,
    action: AirConditionerModeEnum.COOLING_MODE,
    func: 'airConditionerMode',
    loading: false,
    disabled: true,
  },
  {
    label: DeviceCmdItemLabelMap[DeviceCmd.SimSlotSwith],
    status: 'SIM卡',
    operateText: 'ESIM卡',
    cmdKey: DeviceCmd.SimSlotSwith,
    action: SIMCardSlotEnum.SIM,
    func: 'simSlot',
    loading: false,
  }
]

export enum DeviceCmdStatusText {
  DeviceRebootNormalText = '工作中',
  DeviceRebootInProgressText = '重启中...',
  DeviceRebootFailedText = '重启失败',

  DroneStatusOpenNormalText = '开',
  DroneStatusOpenInProgressText = '开机中...',
  DroneStatusOpenFailedText = '关',
  DroneStatusOpenBtnText = '关机',

  DroneStatusCloseNormalText = '关',
  DroneStatusCloseInProgressText = '关机中...',
  DroneStatusCloseFailedText = '开',
  DroneStatusCloseBtnText = '开机',

  DeviceCoverOpenNormalText = '开',
  DeviceCoverOpenInProgressText = '开启中...',
  DeviceCoverOpenFailedText = '关',
  DeviceCoverOpenBtnText = '关闭',

  DeviceCoverCloseNormalText = '关',
  DeviceCoverCloseInProgressText = '关闭中...',
  DeviceCoverCloseFailedText = '开',
  DeviceCoverCloseBtnText = '开启',

  DevicePutterOpenNormalText = '展开',
  DevicePutterOpenBtnText = '闭合',
  DevicePutterOpenInProgressText = '推杆展开中',
  DevicePutterOpenFailedText = '闭合',

  DevicePutterCloseNormalText = '闭合',
  DevicePutterCloseInProgressText = '推杆闭合中',
  DevicePutterCloseFailedText = '展开',
  DevicePutterCloseBtnText = '展开',

  DeviceChargeOpenNormalText = '充电',
  DeviceChargeOpenInProgressText = '充电中...',
  DeviceChargeOpenFailedText = '未充电',
  DeviceChargeOpenBtnText = '断电',

  DeviceChargeCloseNormalText = '断电',
  DeviceChargeCloseInProgressText = '断电中...',
  DeviceChargeCloseFailedText = '充电',
  DeviceChargeCloseBtnText = '充电',

  DeviceFormatInProgressText = '格式化...',
  DeviceFormatFailedText = '格式化失败',

  DroneFormatInProgressText = '格式化...',
  DroneFormatFailedText = '格式化失败',

  DeviceSupplementLightOpenNormalText = '开',
  DeviceSupplementLightOpenInProgressText = '开启中...',
  DeviceSupplementLightOpenFailedText = '关',
  DeviceSupplementLightOpenBtnText = '关闭',

  DeviceSupplementLightCloseNormalText = '关',
  DeviceSupplementLightCloseText = '关闭中...',
  DeviceSupplementLightCloseFailedText = '开',
  DeviceSupplementLightCloseBtnText = '打开',

  AlarmStateOpenNormalText = '开',
  AlarmStateOpenText = '开启中...',
  AlarmStateOpenFailedText = '关',
  AlarmStateOpenBtnText = '关闭',

  AlarmStateCloseNormalText = '关',
  AlarmStateCloseText = '关闭中...',
  AlarmStateCloseFailedText = '开',
  AlarmStateCloseBtnText = '打开',

  BatteryStoreModePlanNormalText = '计划',
  BatteryStoreModePlanText = '切换中...',
  BatteryStoreModePlanFailedText = '应急',
  BatteryStoreModePlanBtnText = '应急',

  BatteryStoreModeEmergencyNormalText = '应急',
  BatteryStoreModeEmergencyText = '切换中...',
  BatteryStoreModeEmergencyFailedText = '计划',
  BatteryStoreModeEmergencyBtnText = '计划',

  DroneBatteryModeMaintenanceInProgressText = '保养中',
  DroneBatteryModeMaintenanceNotNeedText = '无需保养',
  DroneBatteryModeMaintenanceNeedText = '需保养',
  DroneBatteryModeOpenBtnText = '保养',
  DroneBatteryModeCloseBtnText = '关闭保养',

  SdrWorkModeFourGOpenNormalText = '开',
  SdrWorkModeFourGOpenText = '开启中...',
  SdrWorkModeFourGOpenFailedText = '--',
  SdrWorkModeFourGOpenBtnText = '关闭',

  SdrWorkModeFourGCloseNormalText = '--',
  SdrWorkModeFourGCloseText = '关闭中...',
  SdrWorkModeFourGCloseFailedText = '开',
  SdrWorkModeFourCloseBtnText = '开启',

  AirConditionerModeIdelNormalText = '空闲模式',
  AirConditionerModeIdelText = '切换中...',
  AirConditionerModeIdelFailedText = '制冷模式',
  AirConditionerModeIdelBtnText = '制冷模式',

  AirConditionerModeCoolingNormalText = '制冷模式',
  AirConditionerModeCoolingText = '切换中...',
  AirConditionerModeCoolingFailedText = '空闲模式',
  AirConditionerModeCoolingBtnText = '空闲模式',

  SimSlotSwithOpenNormalText = 'Sim卡',
  SimSlotSwithOpenText = '切换中...',
  SimSlotSwithOpenFailedText = 'eSim卡',
  SimSlotSwithOpenBtnText = '切换eSim卡',

  SimSlotSwithCloseNormalText = 'ESim卡',
  SimSlotSwithCloseText = '切换中...',
  SimSlotSwithCloseFailedText = 'Sim卡',
  SimSlotSwithCloseBtnText = '切换Sim卡',

  DrcAiIdentifySetOpenNormalText = '开',
  DrcAiIdentifySetOpenText = '开启中...',
  DrcAiIdentifySetOpenFailedText = '关',
  DrcAiIdentifySetOpenBtnText = '关闭',

  DrcAiIdentifySetCloseNormalText = '关',
  DrcAiIdentifySetCloseText = '关闭中...',
  DrcAiIdentifySetCloseFailedText = '开',
  DrcAiIdentifySetCloseBtnText = '开启',

  DrcAiSpotlightZoomSetOpenNormalText = '开',
  DrcAiSpotlightZoomSetOpenText = '开启中...',
  DrcAiSpotlightZoomSetOpenFailedText = '关',
  DrcAiSpotlightZoomSetOpenBtnText = '关闭',

  DrcAiSpotlightZoomSetCloseNormalText = '关',
  DrcAiSpotlightZoomSetCloseText = '关闭中...',
  DrcAiSpotlightZoomSetCloseFailedText = '开',
  DrcAiSpotlightZoomSetCloseBtnText = '开启',
}

// cmd ws 消息状态
export enum DeviceCmdExecuteStatus {
  Sent = 'sent', // 已下发
  InProgress = 'in_progress', // 执行中
  OK = 'ok', // 执行成功
  Failed = 'failed', // 失败
  Canceled = 'canceled', // 取消或终止
  Timeout = 'timeout', // 超时
  Paused = 'paused', // 暂停中
  Rejected = 'rejected', // 拒绝执行
}

export interface DeviceCmdExecuteInfo {
  biz_code: string,
  timestamp: number,
  sn: string,
  bid: string,
  output:{
    status: DeviceCmdExecuteStatus,
    progress?: {
      percent: number,
      step_key: string,
      step_result: number
    },
    ext?: {
      rate?: number
    }
  }
  result: number,
}

// 所有机场的指令执行状态
export interface DevicesCmdExecuteInfo {
  [key: string]: DeviceCmdExecuteInfo[], // sn --- DeviceCmdExecuteInfo
}
